import AppTextField from "@/components/AppTextField";
import SendCodeButton from "@/components/SendCodeButton";
import AppLoadingButton from "@/components/mui/LoadingButton";
import API from "@/constant/API";
import { VerifyAction } from "@/constant/VerifyConstant";
import { getTaskId, getUserInfo } from "@/redux/slices/user";
import { dispatch } from "@/redux/store";
import axiosInstance from "@/utils/axios";
import { Box, InputAdornment, styled } from "@mui/material";
import { t } from "i18next";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import classes from "@/pages/security/css/index.module.less";
import {useTranslation} from "react-i18next";
import {enqueueSnackbar} from "notistack";
import SimpleHeader from "../components/Headers/SimpleHeader";

const StyledBox = styled(Box)(({theme}) => ({
  // background: 'url(/images/login-bg.svg) no-repeat center',
  // backgroundSize: '100% 100%',
}))

function SecurityEmailBind() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useSelector(state => state.user);
  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');

  const [step, setStep] = useState(1);  // 1 email exist  2 Bind email
  const [tokenModel, setTokenModel] = useState(null);

  const handleSubmit = async (evt) => {
    evt.preventDefault();

    try {
      setLoading(true);

      if (step == 1) {
        const params = {
          email: email,
        };
        const tokenModel = await axiosInstance.post(API.BIND_EMAIL_EXIST, params);
        setTokenModel(tokenModel);
        setStep(2);
      } else {
        const params = {
          email: email,
          code: code,
          sign: tokenModel.sign,
          taskId: getTaskId(),
        };
        await axiosInstance.post(API.EMAIL_BIND, params);
        // TODO: toast 提示用户绑定邮箱成功
        enqueueSnackbar(t('successful'), { variant: 'success' })
        dispatch(getUserInfo());
        navigate(-1);
      }
    } finally {
      setLoading(false);
    }
  }

  const _onEmailChange = (evt) => {
    setEmail(evt.target.value);
    setStep(1);
  }

  if (!user) return null;

  return (<>
    <SimpleHeader />
    <Box className={classes["security-wrap"]}>
      <Box className={classes["security-title-wrap"]}>
        <div className={classes["security-title"]}>{t('email_bind')}</div>
      </Box>

      <form autoComplete="off" onSubmit={handleSubmit}>
        <Box className={classes["column-gap-wrap"]}>
          <AppTextField
            label={t('email')}
            placeholder={t('email')}
            onChange={_onEmailChange}
            required
            value={email}
            fullWidth
            clearable
            onClear={() => setEmail('')}
          />
          {step == 2 && <AppTextField
            label={t('code')}
            placeholder={t('code')}
            onChange={(e) => setCode(e.target.value.trim())}
            required
            value={code}
            fullWidth
            clearable
            onClear={() => setCode('')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SendCodeButton
                    btnText={t('send_code')}
                    action={VerifyAction.BIND_EMAIL}
                    enable={true}
                    params={{
                      email: email,
                    }}
                    onError={(error)=>{
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />}
        </Box>
      </form>
      <Box className={classes["fixed-button"]}>
        <AppLoadingButton
          fullWidth
          loading={loading}
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          onClick={handleSubmit}
        >
          {t('confirm')}
        </AppLoadingButton>
      </Box>

    </Box>
  </>);
}

export default SecurityEmailBind;
